/** Used to initialise `<InviteModal />` as open */
export const INVITE_MODAL_SEARCH_PARAM = 'openInviteModal' as const;
